<template>
    <div id="confirm-project-switch-modal" class="modal-new hidden">
        <svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
            <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>
        <span class="title">Please confirm project switch</span>

        <p class="description">
            You are about to load a project "{{ activeNotification.data.project_name }}". Are you sure you want to close
            the current project and switch to "{{ activeNotification.data.project_name }}".
        </p>

        <div class="buttons-continer">
            <button @click="onConfirm" type="button" class="modal-btn --primary">Confirm</button>
            <button type="button" class="modal-btn --cancel" @click="onCancel">Cancel</button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    data() {
        return {};
    },
    computed: {
        ...mapState('Notifications', {
            activeNotification: 'active'
        })
    },
    methods: {
        async onConfirm() {
            this.$store.dispatch("Loader/showProgressBar", "indeterminate");

            window.UI.hideModal();

            this.$store.dispatch('Notifications/markAsRead', [this.activeNotification]);
            this.$store.dispatch("Projects/setModalSelectedProject", this.activeNotification.data.project_id);
            await this.$root.projectsModal.openProject(false);

            this.$store.dispatch('Notifications/followNotification');
        },

        onCancel() {
            window.UI.hideModal();
        },
    },
};
</script>

<style lang="scss" scoped>
.option-container {
    margin-top: 34px;

    > .switch {
        margin-left: initial;
    }
}
</style>
